<template>
    <div :style="(viewMode ? viewMode.wrapStyle : null)">
        <modal-x :contentStyle="{ maxWidth: '800px' }" :show="showOrderer" @onclose="showOrderer = false">
            <category-orderer v-if="showOrderer" :categories="catNode.childs" v-on:updateOrder="updateOrder"></category-orderer>
        </modal-x>
        <modal-x :contentStyle="{ maxWidth: '800px' }" :show="showCreate" @onclose="showCreate = false">
            <div style="width:100%;height:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;">
                <div style="text-align:left;">
                    <div class="col-xs-12">
                        <div>{{ lang.category.createUnder }}: <span style="color: red;" v-if="catNode !== null">{{ catNode.name }}</span></div>
                    </div>
                    <div class="col-xs-12 agx-col-head">{{lang.category.name}}:</div>
                    <div class="col-xs-12 agx-col-msg">
                        <input class="form-control" style="width:100%;" type="text" name="title" v-model="catInfo.name" />
                    </div>
                </div>
                <br />
                <div class="col-xs-12" style="text-align:right;">
                    <input type="button" value="Create New" class="btn btn-primary" @click="create" />
                </div>
            </div>
        </modal-x>
        <modal-x :show="showEdit" @onclose="showEdit = false" :content-style="{ maxWidth: '800px' }">
            <div>
                <div style="width:100%;height:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;">
                    <div style="text-align:left;">
                        <div class="col-xs-12">
                            <div>
                                {{ lang.category.editingCategory }}: <span style="color: red;" class="btn btn-default"
                                    v-if="catNode !== null">{{ catNode.name }}</span>
                                {{ lang.category.setState }}:
                                <select v-model="catInfo.stateCode" class="form-control"
                                    style="max-width: 100px;display: inline-block;">
                                    <option v-for="(value, propName, index) in catStates" :value.Number="value">
                                        {{ catStatesMap[value] }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-xs-12 agx-col-msg">
                            <input class="form-control" style="width:100%;" type="text" name="title"
                                v-model="catInfo.name" />
                        </div>
                    </div>
                    <br />
                    <div class="col-xs-12" style="text-align:right;">
                        <span class="btn btn-danger" v-if="catInfo.stateCode == catStates.deleted">
                            <span class="glyphicon glyphicon-remove"></span> Click update to confirm Delete >>
                        </span>
                        <input type="button" value="Update" class="btn btn-primary" @click="edit" />
                    </div>
                </div>
            </div>
        </modal-x>
        <div style="text-align:right;" v-if="showCreateNode">
            <span class="btn btn-default" @click="createNewNode"> {{ lang.category.createNewNode }} </span>
        </div>
        <template v-if="viewMode === null">
            <div v-if="catNode !== null" style="margin:0 auto;width:100%;">
                <simple :showCheckbox="showCheckbox" :cat-node="catNode" :parent-node="parentNode" :show-node="showNode"
                    :is-allowed="isAllowed" :show-child="showChild" :has-childs="hasChilds" v-on:catClicked="catClicked"
                    v-on:expandClick="expandClick">
                    <div v-if="showButtons"
                        style="display:flex; flex-direction: row; width:80px;height:34px;background:bisque;align-items: center;justify-content: center;border-left:1px solid white;">                    
                            <span
                                style="display:flex;width:40px;height: 34px; background:bisque;align-items: center;justify-content: center;cursor: pointer;"
                                @click="showCreate = true">{{lang.category.add}}</span>
                            <span
                                style="display:flex;width:40px;height: 34px; background:bisque;align-items: center;justify-content: center;cursor: pointer;"
                                @click="editClicked">{{lang.category.edit}}</span>
                    </div>
                </simple>
                <simple-child :show-node="showNode" :show-child="showChild" v-for="child in catNode.childs">
                    <category :showButtons="showButtons" :showCheckbox="showCheckbox" :cat-node="child" @catSelected="catClicked"
                        :parent-node="catNode" :cat-type="catType" v-on:bubble="onBubble" :selected="selected" v-on:onChanges="fireChanges"
                        :parent-selected="isAllowed" :expand-all="expandAll" :parentLevel="level"></category>
                </simple-child>
            </div>
        </template>
        <template v-else>
            <div :style="(viewMode.wrapStyle)">
                <div :style="(viewMode.wrapStyle)" v-if="catNode" style="">
                    <div style="display: inline-block;" v-if="showNode">
                        <span>
                            <span style="cursor:pointer;" class="glyphicon"
                                :class="{ 'glyphicon-triangle-right': !showChild, 'glyphicon-triangle-bottom': showChild }"
                                @click="expandClick" v-if="hasChilds"></span>
                            <span style="cursor:pointer;width: 14px; height: 16px;" class="glyphicon glyphicon-hand-right-hidden" @click="expandClick"
                                v-else></span>
                        </span>
                        <span style="margin:1px;" class="btn" :class="viewMode.nameClass">
                            <span v-if="showCheckbox" style="margin:5px;" class="glyphicon"
                                :class="{ 'glyphicon-unchecked': !(isAllowed), 'glyphicon-check': isAllowed }"
                                @click="catClicked({ child: catNode, parent: parentNode })"></span>

                            <template v-if="showButtons">
                                <span style="margin:8px;" class="glyphicon glyphicon-plus-sign" @click="showCreate = true">
                                </span>
                                <span style="margin:8px;" class="glyphicon glyphicon-pencil" @click="editClicked"> </span>
                                <span v-if="hasChilds" style="margin:8px;" class="glyphicon glyphicon-sort-by-order" @click="showOrderer=true"></span>
                            </template>
                            
                            <span class="glyphicon glyphicon-eye-open-hide" style="color:green;" v-if="catNode.stateCode == catStates.active"></span>
                            <span class="glyphicon glyphicon-eye-close" style="color:red;" v-else></span>
                            <span style="padding:2px;"
                                @click="catClicked({ child: catNode, parent: parentNode })"> {{ catNode.name }}</span>
                        </span>
                    </div>
                    <div style="margin-left:15px;" :style="{ display: showChild ? '' : 'none' }">
                        <category :user-id="userId" v-for="child in catNode.childs" :showButtons="showButtons" :showCheckbox="showCheckbox" :cat-node="child"
                            @catSelected="catClicked" :parent-node="catNode" :cat-type="catType" v-on:bubble="onBubble" v-on:onChanges="fireChanges"
                            :selected="selected" :parent-selected="isAllowed" :expand-all="expandAll" :parentLevel="level"
                            :viewMode="{ ...viewMode, wrapStyle: { display: isLastParent ? 'inline-block' : '' }, nameClass: (isLastParent || child.childs.length===0)? 'btn btn-default' : '' }">
                        </category>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import modalX from '../components/base/ModalX1.vue';
import apis from '../api/extApi.js';
import simple from '../components/treeviews/simple.vue';
import simpleChild from '../components/treeviews/simpleChild.vue';
import categoryOrderer from './categoryOrderer.vue';

export default {
    components: {
        modalX: modalX,
        category: () => import('./category.vue'),
        simple: simple,
        simpleChild: simpleChild,
        categoryOrderer: categoryOrderer
    },
    computed: {
        lang: function () {
                return this.$store.getters.lang;
        },
        hasChilds() {
            if (this.catNode !== null && this.catNode.childs !== null && this.catNode.childs.length > 0) {
                return true;
            }
            return false;
        },
        isLastParent() {
            if (!this.catNode.childs) return false;
            var length = this.catNode.childs.length;
            if (length > 0) {
                var count = 0;
                for (var i = 0; i < length; i++) {
                    var grandChilds = this.catNode.childs[i].childs;
                    if (!grandChilds) {
                        count += 1;
                    } else if (grandChilds.length === 0) {
                        count += 1;
                    }

                }
                if (count === length) return true;
            }
            return false;
        },
        level() {
            if (this.parentLevel) {
                return this.parentLevel * 1 + 1;
            } else {
                if (this.parentLevel === 0) {
                    return 1;
                }
                return 0;
            }
        },
        isSelected() {
            if (this.selected.catIds.length > 0 && this.catNode !== null) {
                return this.selected.catIds.indexOf(this.catNode.catId) >= 0;
            }
            return false;
        },
        isAllowed() {
            return this.parentSelected || this.isSelected;
        }
    },
    props: {
        "catType": { type: String, default: null }, // listing,shopInfo,
        "userId": String,
        "catNode": Object,
        "showNode": { type: Boolean, default: true },
        "expandChild": { type: Boolean, default: false },
        "expandAll": { type: Boolean, default: false },
        "parentNode": { type: Object, default: null },
        "selected": {
            type: Object,
            default() {
                return { catIds: [], timestamp: 0 };
            }
        },
        "parentSelected": { type: Boolean, default: false },
        "parentLevel": { type: Number },
        "viewMode": { type: Object, default: null },
        "showCheckbox": { type: Boolean, default: true },
        "showButtons": { type: Boolean, default: true },
        "showCreateNode":{type:Boolean,default:false}
    },
    data: function () {
        return {
            showChild: false,
            catCodes: apis.api.settings.catCodes,
            catStates: apis.api.settings.catStates,
            catStatesMap: apis.api.settings.catStatesMap,
            apiClient: apis.api,
            showCreate: false,
            showEdit: false,
            showOrderer: false,
            catInfo: { name: null, parentId: null, userId: this.userId, typeCode: null, stateCode: 0 }
        };
    },
    methods: {
        updateOrder(catArray) {
            // send the updated order to the server
            console.log('catArray', catArray);
            this.apiClient.updateCategoriesPrms(catArray).done((ret) => {
                console.log("updateOrder done", ret);
                this.showOrderer= false;
                this.fireChanges({ type: 'updateOrder', value: ret });
            });
        },
        fireChanges(val) {
            console.log("fire changes", val, this.catNode.name);
            this.$emit('onChanges', val);
        },
        expandClick() {
            this.showChild = !this.showChild;
        },
        createNewNode() {
            this.showCreate = true;
        },
        create() {
            var cat = { ...this.catInfo };
            cat.parentId = this.catNode !== null ? this.catNode.catId : 0;
            console.log('new cat', cat);
            this.apiClient.addCategoryPrms(cat).done((ret) => {
                console.log("create", ret);
                if (ret.ok === true) {
                    if (this.catNode === null) {
                        this.catNode = ret.value;
                    } else {
                        if (this.catNode.childs === null) this.catNode.childs = [];
                        this.catNode.childs.push(ret.value);
                    }
                    this.showCreate = false;
                }
            });
        },
        edit() {
            this.apiClient.updateCategoryPrms(this.catInfo).done((ret) => {
                console.log("update", ret);
                if (ret.ok === true) {
                    this.catNode.name = ret.value.name;
                    this.showEdit = false;
                }
            });
        },
        editClicked() {
            this.catInfo.catId = this.catNode.catId;
            this.catInfo.name = this.catNode.name;
            this.catInfo.parentId = this.catNode.parentId;
            this.catInfo.userId = this.catNode.userId;
            this.catInfo.stateCode = this.catNode.stateCode;
            this.showEdit = true;
        },
        catClicked(catPair) {
            console.log("clicked", catPair);
            this.$emit("catSelected", catPair);
        },
        bubbleUp(val) {
            this.$emit("bubble", val);
        },
        onBubble(val) {
            console.log("onBubble", val);
            this.showChild = true; console.log("show true on bubble", this.catNode.name);
            this.bubbleUp(val);
        },
        bubbleSelection() {
            if (this.isSelected) {
                this.bubbleUp("selection");
            }
        }
    },
    watch: {
        'selected'() {
            this.bubbleSelection();
        }
    },
    created: function () {
        var typeCodeMapped = this.catCodes[this.catType];
        if (typeCodeMapped === undefined) {
            throw "catType :" + this.catType + " property mapped=" + typeCodeMapped + ", cannot be mapped" + JSON.stringify(this.catCodes);
        }
        this.catInfo.typeCode = typeCodeMapped;
        this.showChild = this.expandChild === true || this.expandAll === true;
    },
    mounted: function () {
        this.bubbleSelection();
    },
    destroyed: function () {

    }
}
</script>